// 读取data目录下的默认数据或者localStorage里的数据（未接入后台接口时使用）
// export const readLocalData = (name) => {
// 	let data;
// 	if (localStorage.hasOwnProperty(name)) {
// 		data = JSON.parse(localStorage.getItem(name));
// 	} else {
// 		data = require(`../data/${name}.js`)[name];
// 	}

// 	return data;
// };

/**
 * 通过name获取query的值
 *
 * @param {string} name
 */
export const getQueryString = (name) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
  // const r = window.location.search.substr(1).match(reg);
  const r = reg.exec(window.location.search.substr(1));
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

export const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(
  navigator.userAgent
);
// 给 编辑部的添加属性 做数据筛查
export function optionDescriptionAddPosition(questions, falg) {
  // Dialog
  questions.forEach(element => {
    console.log(22222, element.options);
    (element.childs || []).forEach(ele2 => {
      if (ele2.description.includes(`class="herfaddFlag"`) && !ele2.description.includes("id=")) {
        ele2.description = ele2.description&&ele2.description.replace(`class="herfaddFlag"`, `class="herfaddFlag"id="${element.id}_${ele2.id}"`)
      }

      ele2.options.forEach(ele4 => {
        ele4.description = ele4.description&&ele4.description.replace(`class="herfaddFlag"`, `class="herfaddFlag"id="${ele2.id}_${ele4.id}"`)
      });
      
    });
    element.options.forEach((ele3, index) => {
      if (ele3.description&&ele3.description.includes(`class="herfaddFlag"`) && !ele3.description.includes("id=")) {
        ele3.description = ele3.description.replace(`class="herfaddFlag"`, `class="herfaddFlag"id="${element.id}_${ele3.id}"`)
      }
    })
    //子
  });
  return questions
}

export function noTags(htmlString) {
  //  非bu取
  if (htmlString) return htmlString.replace(/<(?:.|\s)*?>/g, "");
  return "";
}
// 判断是否为PC设备
export const isPC = () => {
  const userAgentInfo = navigator.userAgent;
  const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  const isMobile = agents.some(agent => userAgentInfo.indexOf(agent) > -1);
  return !isMobile;

}

// 判断是否在微信浏览器
export const isWechat = () => {
  if (typeof window != 'object') return;
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(userAgent);
}

export const getDesc = (dataSrc, index) => {
  const pattern = /<([^>]+)>======<\/\1>/g;
  const pattern1 = /======/g;
  const replaceStr = "<p>======</p>";
  let newStr = '';
  if (dataSrc.match(pattern)) {
    const newDescription = dataSrc.replace(pattern, replaceStr);
    newStr = newDescription.split(replaceStr)[index];
  } else if (dataSrc.match(pattern1)) {
    const newDescription = dataSrc.replace(pattern1, replaceStr);
    newStr = newDescription.split(replaceStr)[index];
  } else {
    newStr = index === 0 ? dataSrc : ''
  }
  return newStr;
}